export function isIOS() {
    return (navigator.userAgent || navigator.vendor || window.opera).match(/macintosh|ipad|iphone|ipod/i);
}
